import createMesinData from "@/modules/outlet/mesin/store/state";

const getters = {
    getListSnapMesin: state => state.listSnapMesin,
    getListTagMesin: state => state.listTagMesin,
    getReportConnectionMesin: state => state.reportConnectionMesin,
    getLatestVersionMesin: state => state.latestVersionMesin,
    getLayananByAid: state => state.layananByAid,
    getDetailMesin: state => state.detailMesin,
    getPagination: state => state.pagination,
    getDataCreateMesin: state => state.createMesinData,
    getSearch: state => state.searchKey,
    getListMesinUrut: state => state.listMesinUrut,
}

export default getters